import { audioManagerPlaySound } from './AudioManager.js';
import iconAudioSvg from '../images/icon-audio.svg?raw';


export default class DictionaryListing
{
    constructor()
    {

        this.accordionsContainer = document.querySelector( '.dictionnaire-index .dictionary-languages' );

        if ( !this.accordionsContainer ) {
            // nothing to do
            return;
        }
        this.accordions = Array.from( this.accordionsContainer.querySelectorAll( '.dictionary-language-section' ) );


        this.bindEvents();

        this.revealCompletedWords();

        this.openSomeCompletedAccordions();

    }


    openFirstAccordion()
    {
        this.accordions[ 0 ].querySelector( '.btn-accordion-toggler' ).click();
    }

    openSomeCompletedAccordions() {
        const accordionsWithCompletedWords = this.accordions.filter( accordionEl => {
            const foundCompleted = accordionEl.querySelectorAll( '.mot-container.completed' );
            // console.log( foundCompleted )
            return foundCompleted.length > 0;
        } );


        if ( accordionsWithCompletedWords.length > 0 ) {
            accordionsWithCompletedWords.forEach( accordion => accordion.querySelector( '.btn-accordion-toggler' )
                                                                        .click() )
        }
    }

    bindEvents()
    {
        this.accordions.forEach( accordion => {
            const btnToggler = accordion.querySelector( '.btn-accordion-toggler' );

            btnToggler.addEventListener( 'click', ( e ) =>
            {
                const clicked  = e.target;
                const expanded = clicked.getAttribute( 'aria-expanded' );


                const parentAccordion = clicked.closest( '.dictionary-language-section' );
                if ( expanded === 'true' ) {
                    // already open
                    this.closeAccordion( parentAccordion );
                }
                else {
                    this.openAccordion( parentAccordion );
                }
            } )
        } )
    }


    openAccordion( accordion )
    {


        // console.log( 'openAccordion', accordion )
        const accordionHeader          = accordion.querySelector( '.btn-accordion-toggler' );
        const accordionHeaderContentId = accordionHeader.getAttribute( 'aria-controls' );
        const accordionContainer       = accordion.querySelector( '#' + accordionHeaderContentId );
        const icon                     = accordionHeader.querySelector( '.accordeon-icon' );


        accordionHeader.ariaExpanded  = true;
        accordionContainer.ariaHidden = false;
        accordionContainer.classList.add( 'open' );
        icon.classList.add( 'open' );

        // this.closeAllAccordions( accordion );
    }

    closeAllAccordions( except )
    {


        let accordionsToClose;

        if ( !except ) {
            accordionsToClose = this.accordions;
        }
        else {
            accordionsToClose = this.accordions.filter( accordion => accordion !== except );
        }

        accordionsToClose.forEach( accordion => this.closeAccordion( accordion ) )
    }

    closeAccordion( accordion )
    {

        // console.log( 'closeAccordion', accordion )

        const accordionHeader          = accordion.querySelector( '.btn-accordion-toggler' );
        const accordionHeaderContentId = accordionHeader.getAttribute( 'aria-controls' );
        const accordionContainer       = accordion.querySelector( '#' + accordionHeaderContentId );
        const icon                     = accordionHeader.querySelector( '.accordeon-icon' );

        // console.log('closeAccordion: accordionContainer',accordion, accordionHeader, accordionHeaderContentId, accordionContainer, )

        accordionHeader.ariaExpanded  = false;
        accordionContainer.ariaHidden = true;

        accordionContainer.classList.remove( 'open' );
        icon.classList.remove( 'open' );

    }


    revealCompletedWords()
    {


        // console.log( 'window.SavoirsLegendairesUser', window.SavoirsLegendairesUserWords )

        if ( !(window?.SavoirsLegendairesUserWords ?? null) ) {
            return;
        }


        const words = Array.from( this.accordionsContainer.querySelectorAll( '.mot-container' ) );


        words.forEach( word => {

            const currentWordNation = word.dataset.nation;
            const currentWordWord   = word.dataset.word;
            let isMatch             = false;
            window.SavoirsLegendairesUserWords.forEach( completedWord => {
                if ( completedWord.nation ===
                     currentWordNation &&
                     completedWord.word ===
                     currentWordWord ) {
                    isMatch = true;
                }
            } )

            // if ( isMatch ) {
            this.convertToButton( word, isMatch );
            // }

        } )
    }

    convertToButton( word, isMatch )
    {
        const audio    = word.dataset.audioSrc;
        const imageSrc = word.dataset.imgSrc;

        const btn     = document.createElement( 'button' );
        btn.type      = 'button';
        btn.className = word.className;


        const motTraduit         = word.querySelector( '.mot-traduit' );
        const motFrancais        = word.querySelector( '.mot-francais' );
        const imageContainer     = word.querySelector( '.image-container' );
        const audioIconContainer = word.querySelector( '.icon-audio-container' );


        btn.appendChild( motFrancais );

        if ( isMatch ) {
            btn.classList.add( 'completed' );
            const img = document.createElement( 'img' );
            img.src   = imageSrc;
            imageContainer.appendChild( img );
        }
        else {
            btn.setAttribute( 'disabled', true );
        }

        btn.appendChild( imageContainer );
        btn.appendChild( motTraduit );

        audioIconContainer.innerHTML = iconAudioSvg;
        btn.appendChild( audioIconContainer );

        word.after( btn );
        word.remove();

        btn.addEventListener( 'click', () =>
        {
            audioManagerPlaySound( audio );
        } );
    }

}
